import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import { getRoutes } from 'shared/utils/runtimeBasePath';
import PrivateRoute from 'shared/components/PrivateRoute';
import MainPage from 'app/pages/MainPage';

const NoSession = lazy(() => import('app/pages/NoSession'));

/**
 * Main routes
 *
 * @class      MainRoutes (name)
 * @return     {DOM}
 */
function MainRoutes() {
  const routes = getRoutes();
  return (
    <Routes>
      <Route path={routes.NO_SESSION} element={<NoSession />} />
      <Route
        path="*"
        element={
          <PrivateRoute>
            <MainPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default MainRoutes;
